module.exports = __webpack_public_path__ + "img/FaltaMeiaHora.685e0bc7.png";